import React, { Component } from "react";
import PropTypes from "prop-types";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  CardBody,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import loginImg from "../../assets/img/agent-login.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Swal from "sweetalert2";
import { post } from "helpers/api_helper";

function base64QueryParamDecode(value) {
  if (!value) return "";

  // URLSearchParams decodes %xx but some senders don't encode '+' (space issue)
  const cleaned = String(value).replace(/ /g, "+");

  // Support URL-safe base64 too
  const normalized = cleaned.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized + "===".slice((normalized.length + 3) % 4);

  try {
    const binary = window.atob(padded);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    if (typeof TextDecoder !== "undefined") {
      return new TextDecoder("utf-8").decode(bytes);
    }
    return binary;
  } catch (e) {
    return "";
  }
}
const strongPasswordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()_+\-=[\]{};':"\\|,.<>/?]).{12,}$/;

function getPasswordChecks(password) {
  const value = password || "";
  const specialCharRegex = /[@$!%*?&#^()_+\-=[\]{};':"\\|,.<>/?]/;

  return {
    minLength: value.length >= 12,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /\d/.test(value),
    special: specialCharRegex.test(value),
  };
}


const ResetPasswordSchema = Yup.object().shape({
  passKey: Yup.string()
    .required("Recovery token is required"),
  password: Yup.string()
    .required("New password is required")
    .matches(
      strongPasswordRegex,
      "Min 12 chars, with uppercase, lowercase, number & special character"
    ),

  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});

class ResetPasswords extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      showPasswordTooltip: false,
      initialValues: {
        userName: "",
        userType: "",
        passKey: "",
        password: "",
        confirmPassword: "",
      },
    };
  }
componentDidMount() {
  const token = localStorage.getItem("authToken");

  if (token) {
    this.props.history.replace("/dashboard");
    return;
  }

  const searchParams = new URLSearchParams(this.props.location?.search || "");
  const userFromUrl = base64QueryParamDecode(searchParams.get("user"));
  const typeFromUrl = base64QueryParamDecode(searchParams.get("type"));

  if (userFromUrl || typeFromUrl) {
    this.setState((prev) => ({
      initialValues: {
        ...prev.initialValues,
        userName: userFromUrl || prev.initialValues.userName,
        userType: typeFromUrl || prev.initialValues.userType,
      },
    }));
  }
}
 
  togglePassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };


  handleValidSubmit = async (values, { setSubmitting, resetForm }) => {
    const payload = {
      userName: values.userName,
      userType: values.userType,
      passKey: values.passKey,
      newPassword: values.password,
    };
  
    try {
      // Loading alert
      Swal.fire({
        title: "Resetting password...",
        text: "Please wait",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
      });
  
      const res = await post(`user/resetpassword`, payload);
  
      Swal.fire({
        icon: "success",
        title: "Password reset successful",
        //text: res?.data?.message || "You can now login with your new password.",
        confirmButtonText: "OK",
      }).then(() => {
        // optional:
        //resetForm();
        this.props.history.push("/login");
      });
    } catch (err) {
      // Try to extract a meaningful message from backend
      const apiMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.response?.data?.msg ||
        err?.message;
  
      Swal.fire({
        icon: "error",
        title: "Reset failed",
        text: apiMsg || "Something went wrong. Please try again.",
        confirmButtonText: "OK",
      });
    } finally {
      setSubmitting(false);
    }
  };
  

  render() {
    const { showPassword, initialValues } = this.state;

    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="account-pages">
          <Container>
            <Row className="justify-content-center align-items-center vh-100">
              <Col md={10}>
                <div className="overflow-hidden my-5">
                  <CardBody className="pt-4">
                    <Row>
                      {/* FORM COLUMN */}
                      <Col lg={4}>
                        <div className="login-heading">
                          <h1>Reset Password</h1>
                        </div>

                        <div className="p-2">
                          <Formik
                            enableReinitialize
                            initialValues={initialValues}
                            validationSchema={ResetPasswordSchema}
                            onSubmit={this.handleValidSubmit}
                          >
                            {({ isSubmitting, values }) => {
                              const checks = getPasswordChecks(values?.password);
                              const getCheckIconClass = (isOk) =>
                                isOk
                                  ? "fas fa-check-circle text-success"
                                  : "far fa-circle text-muted";

                              const getCheckTextClass = (isOk) =>
                                isOk ? "text-success" : "text-muted";

                              return (
                              <Form>
                                {/* OTP */}
                                <FormGroup>
                                  <Label className="text-white">Recovery token</Label>
                                  <Field
                                    name="passKey"
                                    type="text"
                                    className="form-control"
                                   
                                    placeholder="Enter Passkey"
                                  />
                                  <ErrorMessage
                                    name="passKey"
                                    component="div"
                                    className="text-danger"
                                  />
                                </FormGroup>

                                {/* TOGGLE */}
                                
                                {/* NEW PASSWORD */}
                                <FormGroup>
                                  <Label className="text-white">New password</Label>
                                  <Field
                                    id="password"
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Enter new password"
                                    onFocus={() => this.setState({ showPasswordTooltip: true })}
                                    onBlur={() => this.setState({ showPasswordTooltip: false })}
                                  />
                              
                                  <ErrorMessage
                                    name="password"
                                    component="div"
                                    className="text-danger"
                                  />
                                  <UncontrolledPopover
                                      placement="right"
                                      target="password"
                                      trigger="focus"
                                     
                                    >
                                      <PopoverHeader>Secure password tips:</PopoverHeader>
                                      <PopoverBody>
                                      <ul className="mb-0 pl-0" style={{ listStyle: "none" }}>
                                        <li className={`d-flex align-items-center mb-1 ${getCheckTextClass(checks.minLength)}`}>
                                          <i className={`${getCheckIconClass(checks.minLength)} mr-2`} />
                                          Minimum 12 characters
                                        </li>
                                        <li className={`d-flex align-items-center mb-1 ${getCheckTextClass(checks.uppercase)}`}>
                                          <i className={`${getCheckIconClass(checks.uppercase)} mr-2`} />
                                          At least one uppercase letter (A–Z)
                                        </li>
                                        <li className={`d-flex align-items-center mb-1 ${getCheckTextClass(checks.lowercase)}`}>
                                          <i className={`${getCheckIconClass(checks.lowercase)} mr-2`} />
                                          At least one lowercase letter (a–z)
                                        </li>
                                        <li className={`d-flex align-items-center mb-1 ${getCheckTextClass(checks.number)}`}>
                                          <i className={`${getCheckIconClass(checks.number)} mr-2`} />
                                          At least one number (0–9)
                                        </li>
                                        <li className={`d-flex align-items-center ${getCheckTextClass(checks.special)}`}>
                                          <i className={`${getCheckIconClass(checks.special)} mr-2`} />
                                          At least one special character (!@#$%^&*)
                                        </li>
                                      </ul>
                                      </PopoverBody>
                                    </UncontrolledPopover>
                                </FormGroup>

                                {/* CONFIRM PASSWORD */}
                                <FormGroup>
                                  <Label className="text-white">Confirm Password</Label>
                                  <Field
                                    name="confirmPassword"
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Confirm password"
                                  />
                                  <ErrorMessage
                                    name="confirmPassword"
                                    component="div"
                                    className="text-danger"
                                  />
                                </FormGroup>

                                <Button
                                  type="submit"
                                  color="primary"
                                  className="w-100"
                                  disabled={isSubmitting}
                                >
                                  Reset Password
                                </Button>
                              </Form>
                              );
                            }}
                          </Formik>
                        </div>
                      </Col>

                      <Col lg={2}></Col>

                      {/* IMAGE COLUMN */}
                      <Col md={6} lg={6} xl={5}>
                        <img
                          src={loginImg}
                          alt="Reset"
                          className="img-fluid"
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </div>
              </Col>
            </Row>
          </Container>

        
        </div>
      </React.Fragment>
    );
  }
}

ResetPasswords.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {};
};

export default withRouter(connect(mapStateToProps, null)(ResetPasswords));
